'use strict';

var React = require('react');

var SvgDetailedPopUpMajor = function SvgDetailedPopUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 3h1v-2h-1.5c-.8 0-1.5.7-1.5 1.5v1.5h2v-1zm6 16h-3v-2h3v2zm2 0h3v-2h-3v2zm-8-2v-1h-2v1.5c0 .8.7 1.5 1.5 1.5h1.5v-2h-1zm13 0h1v-1h2v1.5c0 .8-.7 1.5-1.5 1.5h-1.5v-2zm-15-8v-3h2v3h-2zm0 2v3h2v-3h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3v8h8v-8h-8zm-.5-2c-.8 0-1.5.7-1.5 1.5v9c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5h-9z"
  }));
};

exports.SvgDetailedPopUpMajor = SvgDetailedPopUpMajor;
